import { render, staticRenderFns } from "./BMain.vue?vue&type=template&id=815afb9a&scoped=true&"
import script from "./BMain.vue?vue&type=script&lang=js&"
export * from "./BMain.vue?vue&type=script&lang=js&"
import style0 from "./BMain.vue?vue&type=style&index=0&id=815afb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815afb9a",
  null
  
)

export default component.exports